import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewContainerRef } from "@angular/core";
import { CardAction } from "@features/eda/worksheet/cards/events";
import { CardCreationHelper } from "@features/eda/worksheet/cards/help/card-creation-helper";
import { ModalsService } from "@shared/modals/modals.service";
import { UnitRootTestADF, UnitRootTestADFCard } from "src/generated-sources";

@Component({
    selector: 'unit-root-test-adf-card-help',
    templateUrl: './unit-root-test-adf-card-help.component.html',
    styleUrls: ['./unit-root-test-adf-card-help.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitRootTestADFCardHelpComponent {
    @Input() params: UnitRootTestADFCard;
    @Input() readOnly: boolean;
    @Input() extendedActions: boolean;
    @Output() action = new EventEmitter<CardAction>();

    private cardCreationHelper: CardCreationHelper;

    constructor(
        modalsService: ModalsService,
        viewContainerRef: ViewContainerRef,
    ) {
        this.cardCreationHelper = new CardCreationHelper(
            modalsService,
            viewContainerRef,
            this.action
        );
    }

    get canAddCard() {
        return !this.readOnly && this.extendedActions;
    }

    get stationarityLabel(): string {
        switch (this.params.regressionMode) {
            case UnitRootTestADF.RegressionMode.NO_CONSTANT_NO_TREND:
            case UnitRootTestADF.RegressionMode.CONSTANT_ONLY:
                return "stationary";

            case UnitRootTestADF.RegressionMode.CONSTANT_WITH_LINEAR_TREND:
            case UnitRootTestADF.RegressionMode.CONSTANT_WITH_LINEAR_QUADRATIC_TREND:
                return "trend stationary";
        }
    }

    addACFPlotCard() {
        if (this.canAddCard) {
            this.cardCreationHelper.createACFPlotCard(this.params);
        }
    }

    addDurbinWatsonCard() {
        if (this.canAddCard) {
            this.cardCreationHelper.createDurbinWatsonCard(this.params);
        }
    }
}
